import Swal from "sweetalert2";

/**
 *  Paleta base
 */
const COLORS = {
  primary: "#1976d2",
  success: "#1ab394",
  info: "#23c6c8",
  warning: "#f8ac59",
  error: "#ed5565",
  cancel: "#d33",
  neutral: "#6c757d",
};

/**
 *  Base común para TODOS los swals
 */
const baseSwal = {
  reverseButtons: true,
  buttonsStyling: true,
  focusConfirm: false,
};

const strictMode = {
  focusConfirm: true,
  allowOutsideClick: false,
  allowEscapeKey: false,
};

/**
 *  SUCCESS
 */
export const successSwal = Swal.mixin({
  icon: "success",
  confirmButtonColor: COLORS.success,
  ...baseSwal,
});

/**
 * ERROR
 */
export const errorSwal = Swal.mixin({
  icon: "error",
  confirmButtonColor: COLORS.error,
  ...baseSwal,
});

/**
 * WARNING (confirmación típica)
 */
export const warningSwal = Swal.mixin({
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: COLORS.warning,
  cancelButtonColor: COLORS.cancel,
  ...baseSwal,
});

/**
 * INFO
 */
export const infoSwal = Swal.mixin({
  icon: "info",
  confirmButtonColor: COLORS.info,
  ...baseSwal,
});

/**
 *  PRIMARY (acciones neutras / generales)
 */
export const questionSwal = Swal.mixin({
  icon: "question",
  showCancelButton: true,
  confirmButtonColor: COLORS.primary,
  cancelButtonColor: COLORS.neutral,
  ...baseSwal,
});

/**
 *  DELETE - Caso comun
 */
export const deleteSwal = Swal.mixin({
  icon: "warning",
  showCancelButton: true,
  confirmButtonColor: COLORS.error,
  cancelButtonColor: COLORS.neutral,
  confirmButtonText: "Eliminar",
  cancelButtonText: "Cancelar",
  ...baseSwal,
});

/**
 *  LOADING
 */
export const loadingSwal = Swal.mixin({
  ...baseSwal,
  didOpen: () => {
    Swal.showLoading();
  },
  allowOutsideClick: false,
  showConfirmButton: false,
});
